module.exports = __webpack_public_path__ + "static/media/green-lam.fb2f0ee4.jpeg";